import { render, staticRenderFns } from "./platformRepaymentDetails.vue?vue&type=template&id=0025eba2&scoped=true&"
import script from "./platformRepaymentDetails.vue?vue&type=script&lang=js&"
export * from "./platformRepaymentDetails.vue?vue&type=script&lang=js&"
import style0 from "./platformRepaymentDetails.vue?vue&type=style&index=0&id=0025eba2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0025eba2",
  null
  
)

export default component.exports